import { Box, Drawer, FormGroup } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import Text from "./text/Text";
import { select, transactionSource } from "./messages";
import { transactionTypeData } from "./constants";
import { CustomCheckbox } from "./checkBox/CheckBox";
import Button from "./button/Button";

function TransactionSourceDrawer({ open, handleDrawerClose, formik }) {
  const { values, setFieldValue } = formik;
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleDrawerClose}
      className="filter-drawer-wrapper transaction-source-drawer"
    >
      <Box className="drawer-header">
        <ArrowBackIcon
          sx={{ cursor: "pointer" }}
          onClick={() => handleDrawerClose()}
        ></ArrowBackIcon>
        <Text className="default-text ml-8" size={18} font="bold">
          {transactionSource}
        </Text>
      </Box>
      <Box className="drawer-body" p="20px">
        <FormGroup className="check-box-data">
          {transactionTypeData.map((option) => (
            <Box className="checkbox-items" key={option?.id}>
              <Box className="checkbox">
                <CustomCheckbox
                  key={option.id}
                  disabled={!transactionTypeData.length}
                  checked={(values.transaction_source || []).includes(
                    option?.short_name
                  )}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    const current = values.transaction_source || [];
                    const next = isChecked
                      ? [...current, option?.short_name]
                      : current.filter((v) => v !== option?.short_name);
                    setFieldValue("transaction_source", next);
                  }}
                  label=""
                />
              </Box>
              <Box>
                <Text
                  className="default-text"
                  font="regular"
                  size={16}
                  variant="caption"
                >
                  {option?.label ? option.label : option.short_name}
                </Text>
              </Box>
            </Box>
          ))}
        </FormGroup>
      </Box>
      <Box
        className="drawer-footer"
        p="14px 20px"
        display="flex"
        justifyContent="space-between"
        border="1px solid #F6F3F3"
      >
        <Button
          variant="contained"
          className="submit-btn"
          label={select}
          onClick={() => {
            handleDrawerClose();
          }}
          sx={{ width: "100%" }}
        />
      </Box>
    </Drawer>
  );
}
export default TransactionSourceDrawer;
